import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../ButtonBase/index.js';
import '../../VisualAssets/IconV3/index.js';
import { useIconButton } from './hooks/useIconButton.js';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import { IconV3 as IconV3Memoized } from '../../VisualAssets/IconV3/Icon.js';

var IconButtonComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useIconButton = useIconButton(props),
    buttonProps = _useIconButton.buttonProps,
    iconProps = _useIconButton.iconProps;
  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, buttonProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(IconV3Memoized, iconProps));
});
IconButtonComponent.displayName = 'IconButton';
var IconButton = /*#__PURE__*/React.memo(IconButtonComponent);

export { IconButton, IconButtonComponent };
//# sourceMappingURL=IconButton.js.map
